import { useQueryClient, useMutation } from "@tanstack/react-query";
import { axiosInstance } from "./useAxiosInterceptor";

const deletePhoto = async(photoId: string) => {
    const res = await axiosInstance.delete(`/posts/delete/${photoId}`)
    return res.data
}


const useDeletePhoto = () => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: deletePhoto,
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['bodyCheckPhotos']})
        },
        onError: (error) => {
            console.error('삭제 실패', error)
        }
    })
}

export default useDeletePhoto